export const GET_TINY_KEYS = "GET_TINY_KEYS";
export const SET_TINY_KEYS = "SET_TINY_KEYS";
export const ERROR_TINY_KEYS = "ERROR_TINY_KEYS";
